<template>
  <div>
    <div class="page-header">
      <h3>{{ $t("projects.parent") }} Journal</h3>
    </div>
    <JournalFilter />
    <h4 v-if="projectTasks(null).length" class="mt-4">Inbox</h4>
    <ul class="mt-2 list-group">
      <li v-for="task in projectTasks(null)" :key="task.id" class="list-group-item js-task-details-collapse-container" v-bind:class="{ 'bg-light': task.kind == 'comment' }">
        <QuickTask :task="task"/>
      </li>
    </ul>

    <span v-for="projectArea in projectAreas">
      <span v-for="project in projectArea.projects">
        <span v-if="projectTasks(project.id).length">
          <h4 class="mt-4">{{projectArea.name}} {{project.name}}</h4>
          <ul class="mt-2 list-group">
            <li v-for="task in projectTasks(project.id)" :key="task.id" class="list-group-item js-task-details-collapse-container" v-bind:class="{ 'bg-light': task.kind == 'comment' }">
              <QuickTask :task="task"/>
            </li>
          </ul>
        </span>
      </span>
    </span>
  </div>
</template>

<script>
import QuickTask from "components/QuickTask";
import JournalFilter from "components/JournalFilter";

export default {
  components: {
    QuickTask,
    JournalFilter
  },
  computed: {
    projectAreas: {
      get() {
          return this.$store.state.project_areas
      }
    }
  },
  methods: {
    projectTasks: function(project_id){
      return this.$store.state.tasks.filter(function (task){
        return (task.project_id == project_id && (task.completed === true && task.journaled === true))
      })
      .sort(function(a, b) {
        return new Date(b.completed_at) - new Date(a.completed_at);
      });
    }
  }
};
</script>
